/* eslint-disable max-len */
export default {
  BankSlip: {
    description: 'O boleto bancário será exibido após a confirmação da compra e poderá ser impresso para pagamento em qualquer agência bancária, ou ter o número anotado para pagamento pelo telefone ou internet.',
    submitPayment: 'EFETUAR PAGAMENTO',
    label: 'Boleto',
    update: 'Atualizar',
    gift: 'Clique no botão abaixo para liberar seu acesso aos conteúdos da Empiricus. A partir de agora, a sua experiência como investidor ficará ainda mais completa.',
    koin: {
      stepOptin: {
        title: 'O parcelamento de boleto é processado pela Koin',
        description: 'Para prosseguir com a consulta de opções de parcelamento é preciso que você concorde com o compatilhamento de informações com a Koin segundo os <a target="_blank" href="https://termos.koin.com.br/">Termos de uso</a> e <a target="_blank" href="https://www.koin.com.br/politica-de-privacidade/">Política de Privacidade.</a>',
        termsAndPolicy: 'Li e concordo com os <a target="_blank" href="https://termos.koin.com.br/">Termos de uso</a> e <a target="_blank" href="https://www.koin.com.br/politica-de-privacidade/">Política de Privacidade.</a>'
      },
      stepInstallment: {
        installmentSelect: ' O boleto bancário será exibido após a confirmação da compra e poderá ser impresso para pagamento em qualquer agência bancária, ou ter o número anotado para pagamento pelo telefone ou internet.'
      },
      froudCode: {
        data: '<html>\t\t\r\n  <head>\r\n  <script type="text/javascript" src="https://resources.koin.com.br/scripts/koin.min.js">\r\n  </script>\r\n  \t<script type="text/javascript">\r\n  \t   window.onload = function() {\r\n  \t\tGetKoinFraudID(function (guid) { \t\r\n  \t\tdocument.getElementById(\'fraudId\').innerHTML = guid;});\r\n  \t\t\t}\t\r\n  \t</script>\r\n  </head>\r\n    <body>\r\n         FraudId <span id="fraudId"></span>\r\n    </body>\r\n</html>',
      },
      form: {
        name: {
          label: 'Nome',
          placeholder: 'Digite seu nome completo'
        },
        birthday: {
          label: 'Data de nascimento',
          placeholder: 'DD/MM/AAAA'
        },
        document: {
          label: 'CPF',
          placeholder: 'Ex.: 123.456.789-10'
        },
        phone: {
          label: 'Celular',
          placeholder: 'Ex.: (12) 91234-5678'
        },
        email: {
          label: 'E-mail',
          placeholder: 'Ex.: joananunes@email.com'
        },
        installments: {
          label: 'Escolha a quantidade de parcelas',
          placeholder: 'Ver opções',
        },
      },
    },
  },
  pix: {
    description: 'O QR Code será exibido após a confirmação da compra, escaneie o código com o aplicativo da sua instituição financeira e confirme as informações, e pronto! Você também pode realizar o pagamento utilizando o código PIX que será disponibilizado.',
    submitPayment: 'EFETUAR PAGAMENTO',
    label: 'Pix',
    update: 'Atualizar',
  },
  CreditCard: {
    cardNumber: 'Número do cartão',
    ownerName: 'Nome do titular',
    expirationDate: 'Vencimento',
    cvv: {
      label: 'CVV',
      tooltip: {
        title: 'O que é CVV?',
        text: 'São os três dígitos localizados no verso do cartão. No caso do cartão Amex, são os 4 dígitos localizados na frente.',
      }
    },
    installments: 'Parcelas',
    amount: {
      label: 'Valor a ser pago no cartão',
      placeholder: 'Ex: R$ 20,00',
    },
    firstForm: {
      amount: {
        label: 'Valor a ser pago no cartão 1',
      },
    },
    secondForm: {
      amount: {
        label: 'Valor a ser pago no cartão 2',
      },
    },
    submitPayment: 'EFETUAR PAGAMENTO',
    finishPayment: 'Finalizar pagamento',
    finishRenew: 'Efetuar renovação',
    label: 'Cartão de crédito',
    addCard: 'Adicionar cartão',
    addNewCard: 'Adicionar novo cartão',
    addOtherCard: 'Adicionar outro cartão',
    buyWithOneclick: 'Comprar com 1-Clique',
    selectOneCard: 'Selecione um cartão',
    update: 'Atualizar',
    makePayment: 'Efetuar pagamento',
    disclaimers: {
      creditCards: 'O <strong>Cartão 1</strong> é o <strong>cartão principal da compra</strong> e será o meio considerado para renovações ou eventuais cobranças.',
      creditCardPix: 'O <strong>Cartão de crédito</strong> será o meio considerado para renovações ou eventuais cobranças.'
    }
  },
  EarlyRenewal: {
    expiresIn: 'Sua assinatura expira em',
    newExpiresIn: ' Após a renovação a data de expiração será alterada para',
  },
  confirmPayment: 'Confirmar Pagamento',
  payIn: 'Pague em',
  renewIn: 'Renove em',
  methods: {
    picpay: 'PicPay',
    atarpay: 'AtarPay',
    mercadopago: 'Mercado Pago',
  },
  banks: {
    bb: 'Banco do Brasil S.A.',
    caixa: 'Caixa Econômica Federal',
    santander: 'Banco Santander (Brasil) S.A.',
    bradesco: 'Banco Bradesco S.A',
    itau: 'Itaú Unibanco S.A',
    bs2: 'Banco BS2 S.A',
    inter: 'Banco Inter S.A',
    original: 'Banco Original S.A',
  },
  discount: {
    paymentsMethods: {
      creditcard: 'Desconto válido apenas para pagamento à vista com cartão de crédito',
      bankslip: 'Desconto válido apenas para pagamento por boleto bancário',
      wiretransfer: 'Desconto válido apenas para pagamento por transferência bancária',
      pix: 'Desconto válido apenas para pagamento via Pix',
      picpay: 'Desconto válido apenas para pagamento via PicPay',
      atarpay: 'Desconto válido apenas para pagamento via AtarPay',
      mercadopago: 'Desconto válido apenas para pagamento via Mercado Pago',
    }
  },
  types: {
    pix: {
      payButton: 'Efetuar Pagamento',
    },
    bankSlip: {
      payButton: 'Efetuar Pagamento',
    },
    creditCard: {
      payButton: 'Comprar com 1-Click',
    },
    wireTransfer: {
      payButton: 'Confirmar Pagamento',
    },
    empiricusRewards: {
      payButton: 'Confirmar Pagamento',
    },
  },
  customerKind: {
    pf: 'CPF',
    pj: 'CNPJ',
  }
};
